import docReady from '../../../assets/js/docReady';
import feedbackWatch from '../../shared/articleFeedback/_articleFeedback';

import { clickableTable, scrollableTable } from '../../../assets/js/helpers/table';
import { registerBarChart, registerLineChart } from '../../shared/priceChart/priceChart';
import '../../shared/youtubeVideo/youtubeVideo';
import { registerInterestCalculators } from '../../shared/interestCalculator/interestCalculator';

function canShare() {
    if (navigator.share) {
        return true;
    }
    return false;
}

function socialShare() {
    const shareData = {
        title: 'Keuze.nl nieuws artikel',
        text: 'Hoi! Lees dit artikel op Keuze.nl:',
        url: window.location.href,
    };

    if (canShare()) {
        navigator.share(shareData);
    } else {
        const url = window.location.href;
        const encodedUrl = encodeURIComponent(`Hoi! Lees dit artikel op Keuze.nl: \n ${url}`);
        window.open(`https://wa.me/?text=${encodedUrl}`, '_blank');
    }
}

docReady(() => {
    const socialButton = document.querySelectorAll('.social-share-button');
    socialButton[0].addEventListener('click', () => {
        socialShare();
    });

    document.querySelectorAll('.flamingo-table.table-container')
        .forEach((tableElement) => {
            scrollableTable(tableElement);
            clickableTable(tableElement);
        });

    // Tariff chart
    registerBarChart();
    registerLineChart();

    // Register interestCalculators
    registerInterestCalculators();
});

feedbackWatch();
